'use client';

import { useEffect, useMemo } from 'react';
import type { RouteMetaPayload } from '../../_libs/site-shell/routeMeta';
import { useRouteMetaRegistration } from './RouteMetaContext';

export function RouteMeta({
  metaProps,
  pageTargeting,
  disableRaptiveFooter,
  article,
  post,
  term,
  disablePageTracking,
}: RouteMetaPayload) {
  const { pathname, registerRouteMeta } = useRouteMetaRegistration();

  const payload = useMemo<RouteMetaPayload | null>(() => {
    const hasPayload =
      metaProps ||
      pageTargeting ||
      disableRaptiveFooter !== undefined ||
      article ||
      post ||
      term ||
      disablePageTracking !== undefined;

    return hasPayload
      ? { metaProps, pageTargeting, disableRaptiveFooter, article, post, term, disablePageTracking }
      : null;
  }, [metaProps, pageTargeting, disableRaptiveFooter, article, post, term, disablePageTracking]);

  registerRouteMeta(payload);

  useEffect(() => {
    return () => registerRouteMeta(null, pathname);
  }, [registerRouteMeta, pathname]);

  return null;
}
